const ListSubjects = () => import(/* webpackChunkName: "subject-group" */ '@/views/subject/ListSubjects')
const ViewSubject = () => import(/* webpackChunkName: "subject-group" */ '@/views/subject/ViewSubject')
const ViewDomain = () => import(/* webpackChunkName: "subject-group" */ '@/views/subject/ViewDomain')

export default [
  {
    path: 'subjects',
    name: 'subjects',
    components: {
      studyContent: ListSubjects
    },
    meta: {
      title: '受试者'
    }
  },
  {
    path: 'subject/:subjid',
    name: 'view-subject',
    components: {
      studyContent: ViewSubject
    },
    meta: {
      title: '受试者概况'
    }
  },
  {
    path: 'domain/:stateid',
    name: 'view-domain',
    components: {
      studyContent: ViewDomain
    },
    meta: {
      title: '表单数据'
    }
  }
]
